module.exports = __webpack_public_path__ + "media/images/agreements/link_4-3822372790037bd6e802e0abd5d855cd.png";